/**
 * On Course Drving Reducers
 */
import {
    OCTDRIVING_ACTION,
    ALL_OCTDRIVING,
    ALL_OCTCLUBSHOT,
    ADD_OCTDRIVING,
    FETCH_OCTDRIVING,
    EDIT_OCTDRIVING,
    DELETE_OCTDRIVING,
    FETCH_OCTDRIVINGCHART,
    FETCH_DRIVINGSHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    octdrivinglist:[],
    octdrclubshot:[],
    particularoctdriving:[],
    drivingchart:[],
    drivingshotchart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case OCTDRIVING_ACTION:
            return { ...state, loading: true };       

        case ALL_OCTDRIVING:
            return { ...state, loading: false, octdrivinglist: action.payload };     
       
        case ALL_OCTCLUBSHOT:
            return { ...state, loading: false, octdrclubshot: action.payload };  

        case ADD_OCTDRIVING:
            return { ...state, loading: false };     
         
        case FETCH_OCTDRIVING:
            return { ...state, loading: false, particularoctdriving: action.payload };  
            
        case EDIT_OCTDRIVING:
            return { ...state, loading: false }; 
            
        case DELETE_OCTDRIVING:
            return { ...state, loading: false };   
            
        case FETCH_OCTDRIVINGCHART:
            return { ...state, loading: false, drivingchart: action.payload }; 

        case FETCH_DRIVINGSHOTCHART:
            return { ...state, loading: false, drivingshotchart: action.payload };  
        
        default: return { ...state };

     }
 }